import {
  ContactDetails,
  Environment
} from "@coxauto-ui/cxm/communications/interfaces";
import { fetchWrapper } from "@coxauto-ui/core-http";
import { getBaseUrl, getHeader } from "../config";
import { GetContactDetailsRequest } from "./interfaces/get-contact-details";
import { ResponseError } from "./interfaces/api-error";

export async function getContactDetails(
  data: GetContactDetailsRequest,
  env: Environment
): Promise<ContactDetails> {
  const url = `${getBaseUrl(env)}cxm/contact-details?consumerid=${
    data.consumerId
  }&ConsumerRecordSystem=${data.consumerRecordSystem}`;
  const header = await getHeader();

  const response = await fetchWrapper.getAsync<ContactDetails>(url, header);

  if (response.hasError) {
    const errorBody = response.data as { message?: string } | null;
    const error: ResponseError = {
      isError: true,
      statusCode: response.statusCode,
      errorResult: response.error,
      message: errorBody?.message,
      url
    };
    throw error;
  }

  if (!response.data) {
    const error: ResponseError = {
      isError: true,
      statusCode: response.statusCode,
      errorResult: new Error("no permissions"),
      url
    };
    throw error;
  }

  return response.data;
}
